import React from "react";
import { Button, Container, Row, Col, Form, Accordion, Card, Modal, Tabs, Tab } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';
import DetailScreen from "./DetailScreen";
import UserFinder from "../dialogs/userFinder";
import LocationEditor from "../dialogs/LocationEditor";

export default class OrgDetails extends DetailScreen {
    state = { 
        itemData: null,
        userTokens: [],
        userSites: []
    }

    pathPrefix = "/orgs";
    methodName = "Professional.search";

    async updateData(uuid) {
        await super.updateData(uuid || this.state.pathParams.recordId);
        console.log(this.state.itemData);
    }

    async saveRecord() {
        let reqParams = { ...this.state.itemData };

        let itemData = await context.makeRequest("Professional.saveOrganization", reqParams);
        if (!itemData.error) {
            alert("Saved");
        } else {
            alert("Error: " + itemData.error.message );
        }
    }

    renderMembers() {
        if (this.state.itemData.members.length === 0) {
            return (
                <div>No members yet</div>
            );
        }
        return (
            <div>
                {
                    this.state.itemData.members.map(member => (
                        <div style={ { width: '100%', padding: 10, height: 40 } }>
                            <div style={{ float: 'left', width: '40%' }}>
                                { member.firstName } { member.lastName }
                            </div>
                            <div style={{ float: 'left' }}>
                                { member.email }
                            </div>
                            <div style={{ float: 'right' }}>
                                <Button variant="danger" onClick={ () => {
                                    this.removeUser(member);
                                }}>X</Button>
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

    renderLocations() {
        if ((this.state.itemData.locations || []).length === 0) {
            return (
                <div>No locations yet</div>
            );
        }
        return (
            <div>
                {
                    this.state.itemData.locations.map(location => (
                        <div style={ { width: '100%', padding: 10, height: 60 } }>
                            <div style={{ float: 'left', width: '40%' }}>
                                { location.name }<br/>
                                { location.address }, { location.zip }, { location.city }, { location.country }
                            </div>
                            <div style={{ float: 'right' }}>
                                <Button onClick={ () => {
                                    this.editLocationPushed(location);
                                }}>Edit</Button>
                                <Button variant="danger" onClick={ () => {
                                    this.removeLocation(location);
                                }}>X</Button>
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

    renderSites() {
        if (this.state.itemData.sites.length === 0) {
            return (
                <div>No members yet</div>
            );
        }
        return (
            <div>
                {
                    this.state.itemData.sites.map(site => (
                        <div style={ { width: '100%', padding: 10, height: 40 } }>
                            <div style={{ float: 'left', width: '40%' }}>
                                { site.name }
                            </div>
                            <div style={{ float: 'left' }}>
                                { site.address } { site.city } { site.state } { site.country }
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }

    addLocationPushed() {
        this.extraElement = (
            <LocationEditor
                record={{}}
                onSave={ async (newLocation) => {
                    let result = await context.makeRequest("Professional.manageOrganizationLocation", {
                        organizationUuid: this.state.itemData.uuid,
                        action: 'add',
                        location: newLocation
                    });
                    if (!result.error) {
                        alert("Saved");
                        this.setState({ extraElement: null });
                        this.updateData();
                    } else {
                        alert("Error: " + result.error.message );
                    }
                }}
                onClose={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
            />
        );
        this.setState({  });
    }

    editLocationPushed(location) {
        this.extraElement = (
            <LocationEditor
                record={ location }
                onSave={ async (newLocation) => {
                    let result = await context.makeRequest("Professional.manageOrganizationLocation", {
                        organizationUuid: this.state.itemData.uuid,
                        action: 'edit',
                        location: newLocation
                    });
                    if (!result.error) {
                        alert("Saved");
                        this.extraElement = null;
                        this.setState({ extraElement: null });
                        this.updateData();
                    } else {
                        alert("Error: " + result.error.message );
                    }
                }}
                onClose={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
            />
        );
        this.setState({  });
    }

    addMemberPushed() {
        this.extraElement = (
            <UserFinder
                onSave={ (newMembers) => {
                    this.addMembers(newMembers);
                }}
                onClose={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
            />
        );
        this.setState({  });
    }

    async addMembers(members) {
        let itemData = await context.makeRequest("Professional.manageOrganizationMembership", {
            uuid: this.state.itemData.uuid,
            action: 'add',
            users: members
        });
        if (!itemData.error) {
            alert("Saved");
            this.setState({ extraElement: null });
            this.updateData();
        } else {
            alert("Error: " + itemData.error.message );
        }
    }

    async removeUser(member) { 
        let confirmed = window.confirm("Are you sure?");
        if (confirmed) {
            let itemData = await context.makeRequest("Professional.manageOrganizationMembership", {
                uuid: this.state.itemData.uuid,
                action: 'remove',
                users: [ member ]
            });
            if (!itemData.error) {
                alert("Saved");
                this.setState({ extraElement: null });
                this.updateData();
            } else {
                alert("Error: " + itemData.error.message );
            }
        }
    }

    async removeLocation(location) {
        let confirmed = window.confirm("Are you sure?");
        if (confirmed) {
            let itemData = await context.makeRequest("Professional.manageOrganizationLocation", {
                organizationUuid: this.state.itemData.organizationUuid,
                action: 'delete',
                location: location
            });
            if (!itemData.error) {
                alert("Deleted");
                this.setState({ extraElement: null });
                this.updateData();
            } else {
                alert("Error: " + itemData.error.message );
            }
        }
    }

    selectOwnerPushed() {
        this.extraElement = (
            <UserFinder
                multiSelect={false}
                onSave={ (newOwner) => {
                    this.state.itemData.owner = newOwner[0];
                    this.state.itemData.ownerId = newOwner[0].id;
                    this.extraElement = null;
                    this.setState({  });
                }}
                onClose={ () => {
                    this.extraElement = null;
                    this.setState({});
                }}
            ></UserFinder>
        );
        this.setState({  });
    }

    render() { 
        if (this.checkload() !== true) {
            return this.checkload();
        }

        let didChange = JSON.stringify(this.state.itemData) !== JSON.stringify(this.state.origItemData);
        
        return ( 
            <div>
                { this.extraElement }
                <Tabs 
                    id="uncontrolled-tab-example" 
                    defaultActiveKey={ this.state.pathParams.tab || "Parameters"}
                    onSelect={(k) => {
                        let parts = document.location.hash.toString().split("/");
                        parts[3] = k;
                        delete parts[4];
                        context.navigate(parts.join("/"));
                    }}
                >
                    <Tab eventKey="Parameters" title="Parameters" key="Parameters">
                        <div style={{ display: "block" }}>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        name="name"
                                        value={this.state.itemData.name}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, name: event.target.value } }) }
                                    />
                                </Form.Group> 
                            </div>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>Owner</Form.Label><br/>
                                    { this.state.itemData.owner
                                        ? this.state.itemData.owner.firstName + " " + this.state.itemData.owner.lastName
                                        : "None"
                                    }
                                    <Button
                                            style={{ float: 'right' }}
                                        onClick={ this.selectOwnerPushed.bind(this) }
                                    >Change</Button>
                                </Form.Group>
                            </div>
                        </div>
                        <div style={{ display: "block" }}>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group >
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        name="company"
                                        value={this.state.itemData.email}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, email: event.target.value } }) }
                                    />
                                </Form.Group> 
                            </div>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>Phone</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        name="phone"
                                        value={this.state.itemData.phone}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, phone: event.target.value } }) }
                                    />
                                </Form.Group> 
                            </div>
                        </div>
                        <div style={{ display: "block" }}>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={this.state.itemData.country || ""}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, country: event.target.value } }) }
                                    />
                                </Form.Group>
                            </div>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>State</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={this.state.itemData.state || ""}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, state: event.target.value } }) }
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div style={{ display: "block" }}>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>City</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={this.state.itemData.city || ""}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, city: event.target.value } }) }
                                    />
                                </Form.Group>
                            </div>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={this.state.itemData.address || ""}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, address: event.target.value } }) }
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        
                        <div style={{ display: "block" }}>
                            <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>Latitude</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={this.state.itemData.latitude || ""}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, latitude: event.target.value } }) }
                                    />
                                </Form.Group>
                            </div>
                            <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Label>Longitude</Form.Label>
                                    <Form.Control 
                                        type="text"
                                        value={this.state.itemData.longitude || ""}
                                        onChange={ (event) => this.setState({ itemData: { ...this.state.itemData, longitude: event.target.value } }) }
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <div style={{ display: "block" }}>
                            <div style={{ display: "inline-block", width: "45%", marginRight: 10 }}>
                                <Form.Group>
                                    <Form.Switch
                                        id="switchActive"
                                        label="Active"
                                        checked={ this.state.itemData.active }
                                        onChange={(event) => { 
                                            this.setState({ itemData: { ...this.state.itemData, active: event.target.checked } }) ;
                                        }}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div>
                            Coordinates: { this.state.itemData.latitude } / { this.state.itemData.longitude } <br/>
                            Created: { this.state.itemData.created } <br/>
                            Uuid: { this.state.itemData.uuid }
                            <div className="floatRight">
                                <Button disabled={ !didChange }
                                    onClick={ this.saveRecord.bind(this) }
                                >Save</Button>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="Images" title="Images" key="Images">
                        <Card.Body>
                            <div>        
                                <div style={{ display: "block", fontWeight: 'bold' }}>
                                    Icon
                                </div>
                                <div style={{ display: "block" }}>
                                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                                        <Form.Group >
                                            <Form.Label>URI</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="logoUri"
                                                value={ this.state.itemData.imageData?.icon?.uri || '' }
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.icon || {};
                                                    id.icon = imgData;
                                                    imgData.uri = event.target.value;
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Width</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoWidth"
                                                value={this.state.itemData.imageData?.icon?.width || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.icon || {};
                                                    id.icon = imgData;
                                                    imgData.width = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Height</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.icon?.height || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.icon || {};
                                                    id.icon = imgData;
                                                    imgData.height = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                </div>
                                <div style={{ display: "block" }}>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Top</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.icon?.top || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.icon || {};
                                                    id.icon = imgData;
                                                    imgData.top =Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Bottom</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.icon?.bottom || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.icon || {};
                                                    id.icon = imgData;
                                                    imgData.bottom = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Left</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.icon?.left || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.icon || {};
                                                    id.icon = imgData;
                                                    imgData.left = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Right</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.icon?.right || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.icon || {};
                                                    id.icon = imgData;
                                                    imgData.right = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Preview</Form.Label>
                                            <div style={{ width: '100px' }}>
                                                <img alt="iconPreview" src={ this.state.itemData.imageData?.icon?.uri } style={{ maxWidth: '200px', maxHeight: '100px' }} />
                                            </div>  
                                        </Form.Group> 
                                    </div>
                                </div>
                                <div style={{ display: "block", fontWeight: 'bold' }}>
                                    Logo
                                </div>
                                <div style={{ display: "block" }}>
                                    <div style={{ display: "inline-block", width: "30%", marginRight: 10 }}>
                                        <Form.Group >
                                            <Form.Label>URI</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="logoUri"
                                                value={ this.state.itemData.imageData?.logo?.uri || '' }
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.logo || {};
                                                    id.logo = imgData;
                                                    imgData.uri = event.target.value;
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Width</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoWidth"
                                                value={this.state.itemData.imageData?.logo?.width || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.logo || {};
                                                    id.logo = imgData;
                                                    imgData.width = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Height</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.logo?.height || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.logo || {};
                                                    id.logo = imgData;
                                                    imgData.height = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                </div>
                                <div style={{ display: "block" }}>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Top</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.logo?.top || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.logo || {};
                                                    id.logo = imgData;
                                                    imgData.top = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Bottom</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.logo?.bottom || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.logo || {};
                                                    id.logo = imgData;
                                                    imgData.bottom = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Left</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.logo?.left || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.logo || {};
                                                    id.logo = imgData;
                                                    imgData.left = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Right</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="logoHeight"
                                                value={this.state.itemData.imageData?.logo?.right || 0}
                                                onChange={ (event) => {
                                                    let id = this.state.itemData.imageData || {};
                                                    let imgData = id.logo || {};
                                                    id.logo = imgData;
                                                    imgData.right = Number(event.target.value);
                                                    this.setState({ itemData: { ...this.state.itemData, imageData: id } }) 
                                                }}
                                            />
                                        </Form.Group> 
                                    </div>
                                    <div style={{ display: "inline-block", width: "10%", marginRight: 10 }}>
                                        <Form.Group>
                                            <Form.Label>Preview</Form.Label>
                                            <div style={{ width: '100px' }}>
                                                <img alt="logoPreview" src={ this.state.itemData.imageData?.logo?.uri } style={{ maxWidth: '200px', maxHeight: '100px' }} />
                                            </div>
                                        </Form.Group> 
                                    </div>
                                </div>
                            </div>
                            <div className="floatRight">
                                <Button disabled={ !didChange }
                                    onClick={ this.saveRecord.bind(this) }
                                >Save</Button>
                            </div>
                        </Card.Body>
                    </Tab>
                    <Tab eventKey="Locations" title="Locations" key="Locations">
                        <Card.Body>
                            <div>
                                <Button
                                    onClick={ () => this.updateData() }
                                >Refresh</Button>
                                <Button
                                    onClick={ this.addLocationPushed.bind(this) }
                                >Add</Button>
                            </div>
                            { this.renderLocations() }
                        </Card.Body>
                    </Tab>
                    <Tab eventKey="Members" title="Members" key="Members">
                        <Card.Body>
                            <div>
                                <Button
                                    onClick={ () => this.updateData() }
                                >Refresh</Button>
                                <Button
                                    onClick={ this.addMemberPushed.bind(this) }
                                >Add</Button>
                            </div>
                            { this.renderMembers() }
                        </Card.Body>
                    </Tab>
                    <Tab eventKey="Sites" title="Sites" key="Sites">
                        <Card.Body>
                            <div>
                                <Button
                                    onClick={ () => this.updateData() }
                                >Refresh</Button>
                            </div>
                            { this.renderSites() }
                        </Card.Body>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}